import React from "react";


const Docteur = () => {

  return (
    <div className="position-relative">
        <div className=" bg-white p-5">
            <div>
                <button className="btn btn-prim rounded-pill py-2 px-4" style={{color:'#0056B3',border:'1.5px solid #0056B3'}}><i class="bi bi-arrow-left me-2"></i>Retour</button>
            </div>
            <div className="text-white mt-3 p-3 row" style={{background:'#1A5D1A',borderRadius:'15px'}}>
                <div className="col-12 col-md-5 mx-auto mb-3">
                    <p>Name :</p>
                    <br/>
                    <h3>Markiz Oceane Malwine</h3>
                </div>
                <div className="col-md-3"></div>

                <div className="col-12 col-md-4 mx-auto mb-3">
                    <p className="text-center text-md-end">Appointment of</p>
                    <br/>
                    <h3 className="text-center text-md-end">2025 - 01 - 15</h3>
                    <p className="text-center text-md-end">15h : 00 - 15h : 20</p>
                </div>
            </div>
            <div className="mt-3 p-3" style={{background:'#28A7452B',borderRadius:'10px'}}>
                <strong>Vital signs</strong>
            </div>
            <div className="mt-3 ms-3">
                <ul>
                    <li>Body Temperature :  <strong style={{color:'#EF3826'}}>35.7°C</strong></li>
                    <li>Blood pressure :  <strong>120/90 mmHg</strong></li>
                </ul>
                <p >Note :  <strong>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's </strong></p>
            </div>
            <div className="mt-3 p-3" style={{background:'#28A7452B',borderRadius:'10px'}}>
                <strong>General questions</strong>
            </div>
            <div className="mt-3 ms-3">
                <div className="row">
                    <div className="col-1 mx-auto">
                        <strong>Q :</strong>
                    </div>
                    <div className="col-11 mx-auto">
                        <p>How do you feel / What brings you here today ?</p>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-1 mx-auto align-self-center">
                        <strong>R :</strong>
                    </div>
                    <div className="col-11 mx-auto">
                            <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                <li>Feeling pain in my lower back for several days now,</li>
                                <li>Especially when I sit for long periods of time.</li>
                            </ul>

                    </div>
                </div>
            </div>
            <div className="mt-3 ms-3">
                <div className="row">
                    <div className="col-1 mx-auto">
                        <strong>Q :</strong>
                    </div>
                    <div className="col-11 mx-auto">
                        <p>What are your symptoms ?</p>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-1 mx-auto align-self-center">
                        <strong>R :</strong>
                    </div>
                    <div className="col-11 mx-auto">
                            <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                <li>Feeling pain in my lower back for several days now,</li>
                                <li>Especially when I sit for long periods of time.</li>
                            </ul>

                    </div>
                </div>
            </div>
            <div className="mt-3 ms-3">
                <div className="row">
                    <div className="col-1 mx-auto" style={{marginTop:'5px'}}>
                        <strong>Q :</strong>
                    </div>
                    <div className="col-11 mx-auto">
                        <p>When did your symptoms start ?</p>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-1 mx-auto align-self-center">
                        <strong>R :</strong>
                    </div>
                    <div className="col-11 mx-auto">
                        <strong>12 - 12 - 2025</strong>
                    </div>
                </div>
            </div>
            <div className="mt-3 p-3" style={{background:'#28A7452B',borderRadius:'10px'}}>
                <strong>Maladies / Allergies</strong>
            </div>
            <div className="mt-3">
                <ul className="ms-3">
                    <li>Feeling pain in my lower back for several days now,</li>
                    <li>Especially when I sit for long periods of time.</li>
                </ul>
            </div>
            <div className="mt-3 p-3" style={{background:'#28A7452B',borderRadius:'10px'}}>
                <strong>Historique parental</strong>
            </div>
            <div className="mt-3">
                <ul className="ms-3">
                    <li>Feeling pain in my lower back for several days now,</li>
                    <li>Especially when I sit for long periods of time.</li>
                </ul>
            </div>
            <div className="mt-3 p-3" style={{background:'#28A7452B',borderRadius:'10px'}}>
                <strong>Clinical examinations</strong>
            </div>
            <div className="mt-3">
                <div className="row mt-3 ms-3">
                    <div className="col-3 mx-auto align-self-center">
                        <strong>Auscultation :</strong>
                    </div>
                    <div className="col-9 mx-auto">
                            <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                <li>Red eyes</li>
                                <li>Red tongue</li>
                            </ul>
                    </div>
                </div>
                <div className="row mt-3 ms-3">
                    <div className="col-3 mx-auto align-self-center">
                        <strong>Palpation :</strong>
                    </div>
                    <div className="col-9 mx-auto">
                            <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                <li>Ras</li>
                                <li>Seins fragiles</li>
                            </ul>
                    </div>
                </div>
            </div>
            <div className="mt-3 p-3" style={{background:'#28A7452B',borderRadius:'10px'}}>
                <strong>Diagnosis</strong>
            </div>
            <div className="mt-3 ms-3">
                <p>
                <strong style={{textDecoration:'underline'}}>Suspected Urinary Tract Infection (UTI)</strong> 
                <br/><br/>
                Based on the severity and duration of the symptoms, it is likely acute bronchitis rather than chronic bronchitis. However, if symptoms persist beyond 3 weeks, further investigations may be necessary to rule out other conditions like asthma or chronic obstructive pulmonary disease (COPD).<br/><br/>

                After conducting a thorough clinical examination and reviewing the patient's medical history, it has been determined that the patient is experiencing symptoms consistent with bronchitis. 
                </p>
            </div>
            <div className="mt-3 p-3" style={{background:'#28A7452B',borderRadius:'10px'}}>
                <strong>Medical prescriptions</strong>
            </div>
            <div className="mt-3">
                <div className="mt-3 ms-3" style={{borderLeft:'1px solid #28A745'}}>
                    <div className="d-flex ms-2">
                        <div className="">
                            <strong>Name :</strong>
                        </div>
                        <div className="ms-2">
                            <p className="text-start">Nitrofurantoin 100 mg</p>
                        </div>
                    </div>

                    <div className="d-flex ms-2">
                        <div className="">
                            <strong>Nbr de boites :</strong>
                        </div>
                        <div className="ms-2">
                            <p>5</p>
                        </div>
                    </div>
                    <div className="d-flex ms-2">
                        <div className="align-self-center">
                            <strong>Prises :</strong>
                        </div>
                        <div className="">
                            <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                <li>1 comprime matin</li>
                                <li>1 comprime soir</li>
                            </ul>
                        </div>
                    </div>

                    <div className="d-flex ms-2 mt-3">
                        <div className="">
                            <strong>Durée  :</strong>
                        </div>
                        <div className="ms-2">
                            <p>5 jours</p>
                        </div>
                    </div>
                </div>
                <div className="mt-5 ms-3" style={{borderLeft:'1px solid #28A745'}}>
                    <div className="d-flex ms-2">
                        <div className="">
                            <strong>Name :</strong>
                        </div>
                        <div className="ms-2">
                            <p className="text-start">Nitrofurantoin 100 mg</p>
                        </div>
                    </div>

                    <div className="d-flex ms-2">
                        <div className="">
                            <strong>Nbr de boites :</strong>
                        </div>
                        <div className="ms-2">
                            <p>5</p>
                        </div>
                    </div>
                    <div className="d-flex ms-2">
                        <div className="align-self-center">
                            <strong>Prises :</strong>
                        </div>
                        <div className="">
                            <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                <li>1 comprime matin</li>
                                <li>1 comprime soir</li>
                            </ul>
                        </div>
                    </div>

                    <div className="d-flex ms-2 mt-3">
                        <div className="">
                            <strong>Durée  :</strong>
                        </div>
                        <div className="ms-2">
                            <p>5 jours</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-3 p-3" style={{background:'#28A7452B',borderRadius:'10px'}}>
                <strong>Maladies / Allergies</strong>
            </div>
            <div className="mt-3 ms-3">
                <div>
                    <div className="d-flex ms-2">
                        <div className="">
                            <strong>Name of test :</strong>
                        </div>
                        <div className="ms-2">
                            <p className="">Urinalysis</p>
                        </div>
                    </div>
                    <div className="d-flex ms-2">
                        <div className="">
                            <strong>Notes :</strong>
                        </div>
                        <div className="ms-2">
                            <p className="">To confirm the presence of infection and determine the severity.</p>
                        </div>
                    </div>
                </div>
                <div className="mt-3">
                    <div className="d-flex ms-2">
                        <div className="">
                            <strong>Name of test :</strong>
                        </div>
                        <div className="ms-2">
                            <p className="">Urinalysis</p>
                        </div>
                    </div>
                    <div className="d-flex ms-2">
                        <div className="">
                            <strong>Notes :</strong>
                        </div>
                        <div className="ms-2">
                            <p className="">To confirm the presence of infection and determine the severity.</p>
                        </div>
                    </div>
                </div>
                <div className="d-flex ms-2">
                    <div className="mt-md-4 mt-0">
                        <strong style={{color:'#269226',whiteSpace:'nowrap'}}>Note :</strong>
                    </div>
                    <div className="ms-3">
                        <p style={{textAlign:'justify'}}>
                            Based on the severity and duration of the symptoms, it is likely acutebronchitis rather than chronic bronchitis. However, if symptoms persist beyond3 weeks, further investigations may be necessary to rule out other conditionslike asthma or chronic obstructive pulmonary disease (COPD).
                        </p>
                    </div>
                </div>
                <div className="d-flex ms-2">
                    <div>
                        <strong style={{color:'#269226',whiteSpace:'nowrap'}}>Follow up :</strong>
                    </div>
                    <div className="ms-3">
                        <p style={{textAlign:'justify'}}>
                            in 5 days (21-01-2025)
                        </p>
                    </div>
                </div>
            </div>
            <div className="mt-2 d-flex justify-content-end">
                <button type="button" className="btn btn-prim text-white fw-bold px-4 py-2" style={{background:'#1A5D1A'}}>
                    Export to pdf <i class="bi bi-arrow-down-square ms-2 fw-bold"></i>
                </button>
            </div>
        </div>
    </div>
  );
};

export default Docteur;
